import * as angular from 'angular';

import { IRootScope } from '../../../IRootScope';
import { IWorkspaceService, IConfigurationService } from '../../../services';
import * as events from '../../../common';
import { ComponentDefinition, Workspace } from '../../../models';
import { IWideState } from '../../../IWideState';

interface IStateLevel {
    hasName: boolean;
    name: string;
    displayName?: string;
}

interface IBreadCrumb {
    name: string;
    level3: IStateLevel;
    level4: IStateLevel;
    level5: IStateLevel;
}

class BreadcrumbController implements angular.IComponentController {
    static controllerId = 'wtBreadCrumbController';

    applicationName = 'WiDE';
    friendlyName: string;
    workspace: Workspace;
    state: IBreadCrumb;

    private _watchers: any[];

    static $inject = [
        '$scope',
        '$rootScope',
        '$state',
        'workspaceService',
        'configurationService'
    ];

    constructor(
        private $scope: angular.IScope,
        private $rootScope: IRootScope,
        private $state: angular.ui.IStateService,
        private workspaceService: IWorkspaceService,
        private _configurationService: IConfigurationService
    ) {
    }

    $onInit() {
        const workspace = this.workspaceService.getWorkspace();
        if (workspace) {
            this.setWorkspace(workspace);
        }
        this.setStateName(this.$state.current as IWideState);
        this.$scope.$on(events.applicationConnected, (event, data) => {
            this.setWorkspace(data);
        });

        this.$scope.$watch(
            () => this.$state.current,
            () => this.setStateName(this.$state.current as IWideState),
            true
        );

        this._watchers = [
            this.$rootScope.$on(
                '$stateChangeSuccess',
                (_, toState: IWideState) => this.setStateName(toState)
            )
        ];

        this._configurationService
            .getConfiguration()
            .then(data => this.friendlyName = data.friendlyName);
    }

    $onDestroy() {
        try {
            if (this._watchers && this._watchers.length) {
                this._watchers.forEach(w => w());
            }
        } catch (e) {
            console.error(e);
        }
    }

    private setWorkspace(workspace) {
        this.workspace = workspace;
    }

    private setStateName(state: IWideState) {
        const bc = state.data?.breadcrumbs;
        const vm: IBreadCrumb = {
            name: state.data?.displayName ?? state.name,
            level3: {
                hasName: bc?.level3StateName ? true : false,
                name: bc?.level3StateName ?? '',
                displayName: this.getStateDisplayName(bc?.level3StateName ?? '')
            },
            level4: {
                hasName: bc?.level4 ? true : false,
                name: bc?.level4 ?? ''
            },
            level5: {
                hasName: bc?.level5 ? true : false,
                name: bc?.level5 ?? ''
            }
        };

        this.state = vm;
    }

    private getStateDisplayName(state: string) {
        return this.$state.get(state)?.data?.displayName ?? state;
    }

    navigateTo(state: string) {
        if (this.$rootScope.isEditMode === undefined || this.$rootScope.isEditMode === false) {
            this.$state.go(state);
        }
    }
}

export const wtBreadcrumb: ComponentDefinition = {
    componentId: 'wtBreadcrumb',
    controller: BreadcrumbController,
    template: require('./breadcrumb.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};